// config.js
export const PROXY = 'https://images.autolandauto.com/image-proxy.php?path=';